/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiEngagementRuleFromJSON, ApiEngagementRuleToJSON, } from './ApiEngagementRule';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiLeadScoreAdjustmentRuleFromJSON, ApiLeadScoreAdjustmentRuleToJSON, } from './ApiLeadScoreAdjustmentRule';
import { ApiLeadScoreReasonFromJSON, ApiLeadScoreReasonToJSON, } from './ApiLeadScoreReason';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiLeadScoreFromJSON(json) {
    return ApiLeadScoreFromJSONTyped(json, false);
}
export function ApiLeadScoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adjustmentRule': !exists(json, 'adjustmentRule') ? undefined : ApiLeadScoreAdjustmentRuleFromJSON(json['adjustmentRule']),
        'adjustmentRuleId': !exists(json, 'adjustmentRuleId') ? undefined : json['adjustmentRuleId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'engagementRule': !exists(json, 'engagementRule') ? undefined : ApiEngagementRuleFromJSON(json['engagementRule']),
        'engagementRuleId': !exists(json, 'engagementRuleId') ? undefined : json['engagementRuleId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead': !exists(json, 'lead') ? undefined : ApiLeadFromJSON(json['lead']),
        'leadId': !exists(json, 'leadId') ? undefined : json['leadId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'reason': !exists(json, 'reason') ? undefined : ApiLeadScoreReasonFromJSON(json['reason']),
        'score': !exists(json, 'score') ? undefined : json['score'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiLeadScoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adjustmentRule': ApiLeadScoreAdjustmentRuleToJSON(value.adjustmentRule),
        'adjustmentRuleId': value.adjustmentRuleId,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'engagementRule': ApiEngagementRuleToJSON(value.engagementRule),
        'engagementRuleId': value.engagementRuleId,
        'id': value.id,
        'lead': ApiLeadToJSON(value.lead),
        'leadId': value.leadId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'reason': ApiLeadScoreReasonToJSON(value.reason),
        'score': value.score,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
